import { IconSvg, IconSvgProps } from "./icon"

export default function TaskFill(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M19.156 15.72L15.711 19.164A2.071 2.071 0 0 1 14.248 19.77H6.308A2.07 2.07 0 0 1 4.238 17.7V6.314A2.07 2.07 0 0 1 6.308 4.244H17.693A2.07 2.07 0 0 1 19.763 6.314V14.254A2.07 2.07 0 0 1 19.156 15.72Z" />
      {/* The note, filled, with a check cut out the width of a 1.5 stroke */}
      <path
        d="M19.156 15.72L15.711 19.164A2.071 2.071 0 0 1 14.248 19.77H6.308A2.07 2.07 0 0 1 4.238 17.7V6.314A2.07 2.07 0 0 1 6.308 4.244H17.693A2.07 2.07 0 0 1 19.763 6.314V14.254A2.07 2.07 0 0 1 19.156 15.72ZM15.506 9.549L11.648 13.408A1.316 1.316 0 0 1 9.787 13.408L8.495 12.116A.75 .75 0 0 1 9.555 11.056L10.717 12.218L14.446 8.489A.75 .75 0 0 1 15.506 9.549Z"
        fill="currentColor"
        fillRule="evenodd"
        stroke="none"
      />
    </IconSvg>
  )
}
